export function performBase64Download(base64Data: string, mimeType:string, filename: string):void {
    const linkSource = `data:application/${mimeType};base64,${base64Data}`;
    const downloadLink = document.createElement('a');
    downloadLink.href = linkSource;
    downloadLink.download = filename;
    downloadLink.click();
    downloadLink.remove();
}
